import PageHandlersService from '@/utils/page-handlers-service';
import { DEVICE_WIDTH } from '@/utils/viewport-width';

const pageHandlers = new PageHandlersService();

const init = () => {
    if (DEVICE_WIDTH.isDesktop) {
        const allTab = document.querySelector('.js-reviews-all-tab');
        const allProductsCheckbox = document.querySelector<HTMLInputElement>('.js-reviews-all-products-checkbox');
        const productTabsContainer = document.querySelector('.js-reviews-product-tabs');
        const productTabs = productTabsContainer?.querySelectorAll<HTMLInputElement>('.js-news-filters-item');

        if (allTab && allProductsCheckbox) {
            pageHandlers.set(allTab, () => {
                allProductsCheckbox.checked = true;

                productTabs?.forEach((tab) => {
                    tab.checked = false;
                });
            });
        }
    }
};

const destroy = () => pageHandlers.clear();

const _module = { init, destroy };

export default _module;
